// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root___kuxI","col":"styles_col__3Yp34"};